export var FullStorySampleMode;
(function (FullStorySampleMode) {
    FullStorySampleMode["Static"] = "static";
    FullStorySampleMode["Dynamic"] = "dynamic";
})(FullStorySampleMode || (FullStorySampleMode = {}));
var pageTrackingDefaults = {
    enabled: true,
    activityTracking: {
        enabled: true,
    },
    linkClickTracking: {
        enabled: true,
        trackContent: false,
    },
};
export var defaults = {
    fpjs: {
        enabled: false,
        ossEnabled: false,
        proEnabled: false,
    },
    debug: false,
    pageTracking: pageTrackingDefaults,
    snowplowJsUrl: "https://static.zip.co/trx/3.3.0.js",
    anonymousTracking: false,
    optimizely: { enabled: false },
    ga: { enabled: true },
    crossDomain: { enabled: true, cssClass: "trx-xd" },
    fullStory: { enabled: false },
};
export var withDefaults = function (id, namespace, collectorEndpoint) {
    return Object.assign({}, defaults, {
        appInfo: {
            id: id,
            namespace: namespace,
        },
        collectorEndpoint: collectorEndpoint,
    });
};
